import React from "react";
import { useLanguage } from "../utils/LanguageContext";
const Footer = () => {
  const { language } = useLanguage();
  return (
    <footer
      className={`w-full flex items-center justify-center py-4 bg-slate-900`}
    >
      <h2 className="text-gray-400 text-lg text-center">
        {`© ${new Date().getFullYear()} ${
          language === "en"
            ? "Mwafrika Josué, All rights reserved"
            : "Mwafrika Josué, Tous droits réservés"
        }`}
      </h2>
    </footer>
  );
};

export default Footer;
